import { useNavigate } from 'react-router-dom';
import type { AuthUser } from '../types/auth';

export function useAuthRedirect() {
  const navigate = useNavigate();

  const redirectUser = (loggedInUser: AuthUser | null) => {
    if (!loggedInUser) {
      navigate('/');
      return;
    }

    switch (loggedInUser.role?.toUpperCase()) {
      case 'ADMIN':
        navigate('/admin');
        break;

      case 'HR':
      case 'RECRUITER':
      case 'OPERATIONS':
      case 'MANAGER':
        navigate('/hr');
        break;

      case 'CANDIDATE':
        navigate('/candidate');
        break;

      default:
        navigate('/');
    }
  };

  return { redirectUser };
}